import { render, staticRenderFns } from "./uikit.vue?vue&type=template&id=390daeee&scoped=true&"
import script from "./uikit.vue?vue&type=script&lang=js&"
export * from "./uikit.vue?vue&type=script&lang=js&"
import style0 from "./uikit.vue?vue&type=style&index=0&id=390daeee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390daeee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390daeee')) {
      api.createRecord('390daeee', component.options)
    } else {
      api.reload('390daeee', component.options)
    }
    module.hot.accept("./uikit.vue?vue&type=template&id=390daeee&scoped=true&", function () {
      api.rerender('390daeee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/uikit.vue"
export default component.exports